import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import userService from "../../services/userService";
import { Button, Form } from "react-bootstrap";
import {
  Modal,
  ModalTitle,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "react-bootstrap";
import moment from "moment/moment";
import signatureService from "../../services/signatureService";
import SignatureCanvas from "react-signature-canvas";

export default function SubmitApplication({
  user,
  userData,
  updatePage,
  shake,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [termsAccepted, setTermsAccepted] = useState({
    cbEverify: false,
    cbBackground: false,
    cbDocuments: false,
    cbContinuingEd: false,
    cbRegulatory: false,
    cbInformationCollection: false,
    cbEqualOpp: false,
    cbRepresentations: false,
    cbDisputes: false,
    cbSignature: false
  });
  const [signatureReady, setSignatureReady] = useState(false);
  const [signatureID, setSignatureID] = useState(false);
  // const [checkSignature, setCheckSignature] = useState(false);
  const [submitReady, setSubmitReady] = useState(false);
  const [validated, setValidated] = useState(false);
  const date = moment().format();
  let sigPad = {};
  const [signatureError, setSignatureError] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [modalShow, setModalShow] = useState(false);

  let isSubmitting = false;

  useEffect(() => {
    // if(userData.termsAccepted)
    // console.log(userData);
  }, []);

  const onModalHide = () => {
    setModalShow(false);
  };

  const handleSubmit = async () => {
    if(isSubmitting) return;

    isSubmitting = true;
    try {
      if (!userData.password) {
        await userService.saveUserData(userData.username, "applicantStatus", "complete");
        await userService.saveUserData(userData.username, "password", "pending");
        await userService.saveUserData(userData.username, "signatureID", signatureID);
        await userService.saveUserData(userData.username, "termsAccepted", true);
        await userService.saveUserData(userData.username, "submissionDate", date);
        userData.password = "pending";
        userData.signatureID = signatureID;
        userData.termsAccepted = true;
        userData.submissionDate = date;
      }
      userData.applicantStatus = "complete";
      updatePage();
      setValidated(true);
    } catch (error) {
      setSignatureError(true);
      setErrorMessage(t("submit.errorSubmitting"));
    }

    isSubmitting = false;
  };

  const handleValidate = (cb) => {
    const updatedObject = termsAccepted;
    updatedObject[cb] = !updatedObject[cb];
    if (updatedObject.cbBackground && updatedObject.cbDisputes && updatedObject.cbEqualOpp && updatedObject.cbEverify
      && updatedObject.cbInformationCollection && updatedObject.cbRegulatory && updatedObject.cbRepresentations
      && updatedObject.cbSignature && updatedObject.cbContinuingEd && updatedObject.cbDocuments)
      setSignatureReady(true)
    else
      setSignatureReady(false);

    setTermsAccepted(updatedObject);
  }

  const clearCanvas = () => {
    sigPad.clear();
    setSignatureError(false);
  };

  const handleSig = async () => {
    if (!sigPad.isEmpty()) {
      try {
        let signatureObject = {
          signatureUser: userData.username,
          signatureUserName: userData.empInfo.firstName + " " + userData.empInfo.lastName,
          signatureTitle: "Employee Application Terms and Conditions",
          signatureCompany: userData.agencyInfo.name,
          signature: sigPad.getTrimmedCanvas().toDataURL("image/png")
        }
        let { data: signature } = await signatureService.createSignature(signatureObject);
        let signatureIDResponse = signature._id;
        setSignatureID(signatureIDResponse);
        console.log(signature);
        setSubmitReady(true);
        setSignatureError(false);
      } catch {
        setSignatureError(true);
        setErrorMessage(t("submit.errorSavingSignature"));
      }
    } else {
      setSignatureError(true);
      setErrorMessage(t("submit.provideSignature"));
    }
  }

  // const handleSMS = async () => {
  //   let signatureObject = {
  //     signatureUser: userData.username,
  //     signatureUserName: userData.empInfo.firstName + " " + userData.empInfo.lastName,
  //     signatureTitle: "Employee Application Terms and Conditions",
  //     signatureCompany: userData.agencyInfo.name
  //   }
  //   let { data: signature } = await signatureService.createSignature(signatureObject);
  //   // console.log(signature);

  //   let signatureIDResponse = signature._id;
  //   setSignatureID(signatureIDResponse);

  //   let newMessage = {
  //     messageTo: "+1" + userData.empInfo.phoneNumber.replace(/\D/g, ''),
  //     messageText: "Application Link To Sign Terms and Conditions: https://sign.sembratest.com/docSign/" + signatureIDResponse,
  //     messageUser: userData.username,
  //     messageFrom: "Employee Application"
  //   }
  //   // console.log(newMessage)

  //   let { data: SMSReturn } = await signatureService.sendSignatureText(newMessage);
  //   setSignatureReady(false);
  //   setCheckSignature(true);
  // }

  // const handleSignatureVerify = async () => {
  //   const { data: signatureVerification } = await signatureService.verifySignature(signatureID);
  //   // console.log(signatureVerification);
  //   if (signatureVerification === "Verified") {
  //     setCheckSignature(false);
  //     setSubmitReady(true);
  //   } else
  //     shake()
  // }

  return (
    <>
      <Modal show={modalShow} centered>
        {" "}
        <ModalHeader as="span" className="alert alert-warning">
          <ModalTitle as="h4">{t("submit.incompleteTasksTitle")}</ModalTitle>
        </ModalHeader>
        <ModalBody as="section">
          <p>{t("submit.incompleteTasksLead")}</p>
          <p>{t("submit.incompleteTasksBody")}</p>
        </ModalBody>
        <ModalFooter as="footer">
          <Button variant="outline-primary" onClick={onModalHide}>
            {t("submit.confirm")}
          </Button>
        </ModalFooter>
      </Modal>
      {userData.applicantStatus === "complete" || userData.applicantStatus === "newDoc" || userData.applicantStatus === "synced" ? (
        <section className="main-section">
          <h2>{t("submit.submitSuccessTitle")}</h2>
          <section className="main-section-content text-start">
            <p>
              <strong>{t("submit.congratulations")} </strong>
            </p>

            <p>{t("submit.applicationSubmitted")}</p>

            <p> {t("submit.officeContact")}</p>

            <p><b>{t("submit.ivrid", { id: userData.password })}</b></p>
            {userData.password === "pending" && <p style={{ color: 'red' }}><b>{t("submit.ivridPending")}</b></p>}
            <p><b>{t("submit.trainingPassword")}</b></p>

            <p>{t("submit.phase4Continue")}</p>
            <p>{t("submit.phase4Note")}</p>
            <div className="d-flex flex-column">
              <Link className="btn btn-primary mb-4" to="../phase4-upload-documents">
                {t("submit.uploadDocuments")}
              </Link>
              <Button
                className="btn btn-primary"
                onClick={() => window.open(
                  'https://' + userData.agencyInfo.agencyCode + 'training.sembra1.com',
                  '_blank'
                )}
              >
                {t("submit.prerequisites")}
              </Button>
            </div>
            {/* <div className="btn-bar text-end">
              <Button
                onClick={() => userService.logout()}
                variant="primary"
              >
                Logout
              </Button>
            </div> */}
          </section>
        </section>
      ) : (
        <section>
          <section className="main-section">
            <h2>{t("submit.title")}</h2>
            {/* Page Instructions  */}
            <section className="main-section-content text-start">
              <p>
                <strong>{t("submit.allInfoProvided")}</strong>{" "}
              </p>
              <p>{t("submit.reviewAccept")}</p>
              <p>{t("submit.afterAccept")}</p>
              <div className="alert alert-info">
                <p>{t("submit.requirementsLead")}</p>
                <p className="mb-0">{t("submit.requirementsBody")}</p>
              </div>
            </section>
          </section>

          {/* Terms and Conditions  */}
          <section className="main-section">
            <h2>{t("submit.termsTitle")}</h2>
            <div className="main-section-content">
              <section className="text-start">
                <p>{t("submit.agreeFollowing")}</p>
                <Form validated={validated} noValidate>
                  <Form.Check
                    className="mb-3"
                    type="checkbox"
                    id="cbEverify"
                    label={t("submit.terms.term1")}
                    name="cbEverify"
                    onChange={() => handleValidate("cbEverify")}
                    required
                    feedback={t("submit.mustAgree")}
                    feedbackType="invalid"
                  />
                  <Form.Check
                    className="mb-3"
                    type="checkbox"
                    id="cbBackground"
                    label={t("submit.terms.term2")}
                    name="cbBackground"
                    onChange={() => handleValidate("cbBackground")}
                    required
                    feedback={t("submit.mustAgree")}
                    feedbackType="invalid"
                  />
                  <Form.Check
                    className="mb-3"
                    type="checkbox"
                    id="cbDocuments"
                    label={t("submit.terms.term3")}
                    name="cbDocuments"
                    onChange={() => handleValidate("cbDocuments")}
                    required
                    feedback={t("submit.mustAgree")}
                    feedbackType="invalid"
                  />
                  <Form.Check
                    className="mb-3"
                    type="checkbox"
                    id="cbContinuingEd"
                    label={t("submit.terms.term4")}
                    name="cbContinuingEd"
                    onChange={() => handleValidate("cbContinuingEd")}
                    required
                    feedback={t("submit.mustAgree")}
                    feedbackType="invalid"
                  />
                  <Form.Check
                    className="mb-3"
                    type="checkbox"
                    id="cbRegulatory"
                    label={t("submit.terms.term5")}
                    name="cbRegulatory"
                    onChange={() => handleValidate("cbRegulatory")}
                    required
                    feedback={t("submit.mustAgree")}
                    feedbackType="invalid"
                  />
                  <Form.Check
                    className="mb-3"
                    type="checkbox"
                    id="cbInformationCollection"
                    label={t("submit.terms.term6")}
                    name="cbInformationCollection"
                    onChange={() => handleValidate("cbInformationCollection")}
                    required
                    feedback={t("submit.mustAgree")}
                    feedbackType="invalid"
                  />
                  <Form.Check
                    className="mb-3"
                    type="checkbox"
                    id="cbEqualOpp"
                    label={t("submit.terms.term7")}
                    name="cbEqualOpp"
                    onChange={() => handleValidate("cbEqualOpp")}
                    required
                    feedback={t("submit.mustAgree")}
                    feedbackType="invalid"
                  />
                  <Form.Check
                    className="mb-3"
                    type="checkbox"
                    id="cbRepresentations"
                    label={t("submit.terms.term8")}
                    name="cbRepresentations"
                    onChange={() => handleValidate("cbRepresentations")}
                    required
                    feedback={t("submit.mustAgree")}
                    feedbackType="invalid"
                  />
                  <Form.Check
                    className="mb-3"
                    type="checkbox"
                    id="cbDisputes"
                    label={t("submit.terms.term9")}
                    name="cbDisputes"
                    onChange={() => handleValidate("cbDisputes")}
                    required
                    feedback={t("submit.mustAgree")}
                    feedbackType="invalid"
                  />
                  <Form.Check
                    className="mb-3"
                    type="checkbox"
                    id="cbSignature"
                    label={t("submit.terms.term10")}
                    name="cbSignature"
                    onChange={() => handleValidate("cbSignature")}
                    required
                    feedback={t("submit.mustAgree")}
                    feedbackType="invalid"
                  />
                  <section className="text-center">
                    {signatureReady && !submitReady ? (
                      <div>
                        <p className="alert alert-success text-start">
                          {t("submit.termsAcceptedSign")}
                        </p>
                        <div>
                          <SignatureCanvas
                            ref={(ref) => {
                              sigPad = ref;
                            }}
                            penColor="#0000c2"
                            backgroundColor="white"
                            canvasProps={{ className: "sigCanvas" }}
                          />
                        </div>
                        {signatureError && (
                          <p className="alert alert-danger">{errorMessage}</p>
                        )}
                        <div className="btn-bar">
                          <button className="btn btn-primary" type="button" onClick={handleSig}>
                            {t("common.save")}
                          </button>
                          <button className="btn btn-danger" type="button" onClick={clearCanvas}>
                            {t("common.clear")}
                          </button>
                        </div>
                        {/* <p className="alert alert-success text-start">
                          Terms accepted. Click the button below to submit your
                          application
                        </p>
                        <Button variant="primary" type="button" onClick={handleSMS}>
                          Send SMS Text for Signature
                        </Button> */}
                      </div>
                    ) : !submitReady && (
                      <p className="alert alert-danger text-start">
                        {t("submit.acceptAllTerms")}
                      </p>
                    )}
                  </section>
                  {/* {checkSignature && (
                    <section className="text-center mt-3">
                      <Button variant="primary" type="button" onClick={handleSignatureVerify}>
                        Click Here Once You Have Completed Signature Link Sent To Phone
                      </Button>
                      <p className="alert alert-danger text-start mt-2">
                        Signature Not Yet Verified
                      </p>
                    </section>
                  )} */}
                  {submitReady && (
                    <section className="text-center mt-3">
                      <p className="alert alert-success text-center">
                        {t("submit.termsAcceptedClick")}
                      </p>
                      <Button variant="primary" type="button" onClick={handleSubmit}>
                        {t("submit.submitButton")}
                      </Button>
                    </section>
                  )}
                </Form>
              </section>
            </div>
          </section>
        </section>
      )}
    </>
  );
}
